import { getApi } from './api-injector';

export async function secureFetch(url: string): Promise<Response> {
  return await getApi().getFile(url);
}

/**
 * Fetches from a public URL (e.g., Azure Blob with SAS token).
 * Does not include authentication headers since the URL contains its own authorization (SAS token).
 * Includes retry logic for transient failures.
 */
export async function publicFetch(
  url: string,
  options?: {
    method?: 'GET' | 'POST';
    body?: BodyInit | null;
    retryCount?: number;
  }
): Promise<Response> {
  const retryCount = options?.retryCount ?? 3;

  const isAzurite = url.includes('127.0.0.1:10000') || url.includes('localhost:10000');

  let retry = retryCount > 0 ? 0 : -1;

  while (retry++ <= retryCount) {
    try {
      const fetchOptions: RequestInit = {
        mode: 'cors',
        method: options?.method ?? 'GET',
        body: options?.body ?? undefined,

        // 🔑 THIS IS THE IMPORTANT BIT
        cache: isAzurite ? 'no-store' : 'no-cache',

        headers: isAzurite
          ? {
              'Accept-Encoding': 'identity',
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              Pragma: 'no-cache'
            }
          : undefined
      };

      const response = await fetch(url, fetchOptions);

      if (!response.ok) {
        console.warn(`publicFetch: Response not OK. Status: ${response.status}, URL: ${url}`);
      }

      return response;
    } catch (error) {
      console.error('publicFetch error:', error, 'URL:', url);

      if (retry < retryCount) {
        await new Promise(resolve => setTimeout(resolve, retry * 1000));
      }
    }
  }

  return new Response(null, {
    status: 500,
    statusText: 'Failed after retries'
  });
}
